import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            Greetings, travelers of the digital realm. I am{" "}
            <span className="blue-text">Iftikhar Hussain</span>, a tech artisan hailing from the serene landscapes of{" "}
            <span className="blue-text">Sibsagar, Assam, India.</span>
            <br />
            <br />
            🚀{" "}
            <b className="purple">
              Virtuoso of Code | Digital Architect | Curious Artisan
            </b>
            <br />
            <br />
            <ImPointRight /> My daily pursuit involves{" "}
            <b className="purple">
              sculpting web applications, deciphering emerging technologies, and
              continuously refining my craft
            </b>
            .<br />
            From weaving modern UIs to orchestrating complex real-world tools, I
            am wholly devoted to the pursuit of hands-on mastery.
            <br />
            <ImPointRight /> At present, my curiosity leads me to expand my
            repertoire in{" "}
            <b className="purple">
              full-stack development, the delicate art of AI prompt engineering,
              mobile app creation, and database architecture
            </b>
            .<br />
            I take immense joy in transmuting abstract ideas into functional,
            fast, and exquisitely user-friendly digital products.
            <br />
            <ImPointRight /> While my journey has granted me a foundational
            glimpse into the clandestine arts of{" "}
            <b className="purple">ethical hacking</b>, my primary obsession
            remains anchored in{" "}
            <b className="purple">
              building, designing, and solving tangible real-world enigmas
              through technology
            </b>
            .
            <br />
            <ImPointRight /> When I step away from the canvas of code, I don my
            alter ego: <b className="blue-text">Spidy 🎮</b>. A{" "}
            <b className="purple">hardcore gaming aficionado</b> who finds solace
            in the chaotic realms of{" "}
            <b className="purple">GTA Online, Day-Z, PUBG, and CS:GO</b>.
            <br />
            <br />
            <ImPointRight /> 🔥<b className="red-text">The grand design? </b>{" "}
            Keep forging. Keep discovering. Keep evolving toward{" "}
            <b className="purple">an undeniable success</b>. The grand
            performance never ceases! 🚀
          </p>

          <h2>"Quote"</h2>
          <p style={{ color: "rgb(155 126 172)" }}>
            “A river never seeks approval to carve its path—so why should you
            wait to shape your own?”{" "}
          </p>
          <footer className="blockquote-footer">Iftikhar Hussain</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
